import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';

const USER_PRIVACY_TAG = 'UserPrivacy';

// API module for fetching user data
export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/user/',
  }),
  tagTypes: [USER_PRIVACY_TAG],
  endpoints: builder => ({
    // STATUS
    // Fetch the user status
    getUserStatus: builder.query({
      query: () => ({ url: 'status' }),
    }),
    // Request the verification email to be sent
    verifyEmail: builder.mutation({
      query: () => ({ url: 'status', method: 'POST', data: { action: 'verify-email' } }),
    }),

    // PRIVACY
    // Fetch the user privacy settings
    getUserPrivacy: builder.query({
      query: () => ({ url: 'privacy/' }),
      providesTags: [USER_PRIVACY_TAG],
    }),
    // Update the user privacy settings
    updateUserPrivacy: builder.mutation({
      query: ({ id, ...updatedInterestship }) => ({
        url: 'privacy/',
        method: 'PATCH',
        data: updatedInterestship,
      }),
      invalidatesTags: [USER_PRIVACY_TAG],
    }),
  }),
});

export const {
  useGetUserStatusQuery,
  useGetUserPrivacyQuery,
  useUpdateUserPrivacyMutation,
  useVerifyEmailMutation,
} = userApi;
